export default "__VITE_ASSET__BPNLVAh5__"